// extracted by mini-css-extract-plugin
export default {"main":"_3cf26255a0 _3906ad33dd","xmark":"_9843fcf52a","fl_img":"eaac2eb74c _8d470990c7"};